import { axios } from "@/utils/request";

// 企业荣誉
export const Honordata = () => axios.get('/jeecg-system/frontend/companyHonour/list_all')

// 社会责任
export const Shehuizeren = (year) => axios.get('/jeecg-system/frontend/socialLiability/list_all',{params:{year}})